export default {
  props: {},
  data: function () {
    return {
      // linkPath: "/icd10/",
    };
  },
  computed: {
    linkPath: function () {
      return this.$router.options.base + "icd10/";
    },
  },
  methods: {
    hideRanges(str) {
      return str.replace(/\([^\0]*\)$/gim, "");
    },
    // returns the parent code, eg) "H02.21" => "H02.2"
    // if level is supplied returns that level, eg) level 3 "H02.21" => "H02"
    codeParent(code, level) {
      if (!level) {
        level = -1; // will remove char from end of string
      } else if (level > 3) level++; // if >3 there will be a decimal point we'll need to take into account
      level = Math.max(3, level);
      let rtn = code.substring(0, level); // take the first (level) characters
      rtn = rtn.replace(/\.$/, ""); // remove period if last character
      return rtn;
    },
    simplifyLaterality(str) {
      let style = "style='font-weight: bold; color:";
      let od = `<span ${style}green;'>$1</span>`;
      let os = `<span ${style}blue;'>$1</span>`;
      // let upper = `<span ${style}#25c207;'>$1</span>`;
      // let lower = `<span ${style}#7a1b92;'>$1</span>`;
      let ou = `<span ${style}purple;'>$1</span>`;
      let bilateral = `<span ${style}#b66600;'>$1</span>`;
      let unspecified = `<span ${style}#b66600;'>$1</span>`;
      //   let unspecified = `<span ${style}#f0f0f0;'>unspecified</span>`;
      str = str.replace(/(right( eye(lid)?)?([ ]?,)?)/gi, od);
      str = str.replace(/(left( eye(lid)?)?([ ]?,)?)/gi, os);
      str = str.replace(/(both eyes([ ]?,)?)/gi, ou);
      str = str.replace(/(bilateral([ ]?,)?)/gi, bilateral);
      str = str.replace(/(unspecified([ ]?,)?)/gi, unspecified);
      // str = str.replace(/(upper)/gi, upper);
      // str = str.replace(/(lower)/gi, lower);
      str = str.replace(/Type 1/gi, "<b>Type 1</b>");
      str = str.replace(/Type 2/gi, "<b>Type 2</b>");
      str = str.replace(/mild/gi, "<u>mild</u>");
      str = str.replace(/moderate/gi, "<u>moderate</u>");
      str = str.replace(/severe/gi, "<u>severe</u>");
      str = str.replace(/nonproliferative/gi, "<i>nonproliferative</i>");
      str = str.replace(
        /without complications/gi,
        `<span ${style}green;'>without complications</span>`
      );
      str = str.replace(/without/gi, "<i>without</i>");
      return str;
    },
    // todo - make this use router-links instead of standard a tags so we don't have to worry about changes to the paths.
    addIcdLinks(note) {
      let link = null;
      let rangeRegex = /([A-Za-z]\d\d\.?\d{0,3}-[A-Za-z]\d\d\.?\d{0,3})/gim;
      let rangeResult = rangeRegex.test(note);
      if (rangeResult) {
        link = note.replace(rangeRegex, `<a href='${this.linkPath}$1'>$1</a>`);
      } else {
        link = note.replace(
          /([A-Za-z]\d\d\.?\d{0,3})/gim,
          `<a href='${this.linkPath}$1'>$1</a>`
        );
      }

      return link;
    },
  },
};
